import React, { useContext, useEffect, useRef, useState } from 'react'
import profi from '../src/image/user (3).png'
import { FaPen,FaCheck  } from "react-icons/fa";
import { GiCrownCoin } from "react-icons/gi";
import { FaUserFriends } from "react-icons/fa";
import { MdImageNotSupported } from "react-icons/md";

import tal from '../src/image/abc.webp'
import kyc from '../src/image/kyc.png'
import { NavLink, useNavigate } from 'react-router-dom';
import './App.css'
import { toast } from 'react-toastify'; 
import { Modal } from 'react-bootstrap';
import { ProfileContext } from './ProfileContext';
import { Api_Url } from './APIUrl';
import { useToken } from './Store';

const Profile = () => {

  const [dataone, setDataone] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(""); 
  const [kycStatus, setKycStatus] = useState(""); // Initial status is empty
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [profilephoto, setprofilephoto] = useState("");
  // Fetch profile data
   
  const fetchProfile = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(`${Api_Url}api/profile`, requestOptions);
      const result = await response.json();

      if (result.success) {
        setDataone(result.data.user);
        setName(result.data.user.name);  
        setKycStatus(result.data.user.kyc_status);  
        setprofilephoto(result.data.user.profile_photo);  
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  // Update profile
  const updateProfile = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);

      const formdata = new FormData();
      formdata.append("name", name);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      const response = await fetch(`${Api_Url}api/profile`, requestOptions);
      const result = await response.json();

      if (result.data.user) {
        setDataone(result.data.user); // Update local state with new data
        setIsEditing(false); // Exit edit mode
       
      }else if (result.message === "Token has expired.") {
        // Token has expired, navigate to the login page
        localStorage.removeItem("token");  // Optionally remove the expired token
        window.location.href = "/";  // Redirect to login page
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  // Handle Edit Click
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // Handle Save Click
  const handleSaveClick = () => {
    updateProfile();
  };

  // Handle Input Change
  const handleChange = (e) => {
    setName(e.target.value);
  };


    const handleModal = (message) => {
      setModalMessage(message);
      setModalIsOpen(true);
    };


  useEffect(() => {
    fetchProfile();
  }, []);

  const navigate = useNavigate();
  
  const { logout } = useToken(state => state);


 const handleLogout = () => {
    logout(); 
    navigate('/'); 
  };
  
  // const Navigate= useNavigate()
    // useEffect(() => { 
    //   if(!localStorage.getItem('token')){ 
    //       Navigate("/") 
    //   }
    // }, [])





    


  return (
    <div>
           <div className='container-fluid  mt-5'>
        <div className='row '>
          <div className='col-lg-12 col-md-5 col-sm-12 px-0'>
   <div style={{backgroundColor:'#cde8f86b',boxShadow:'0 .5rem 1rem rgba(0,0,0,.15)', borderRadius:'12px'}}> 
               <div  className='mt-2' style={{display:'flex', justifyContent:'center'}}>

               <img src={profilephoto == null ? profi : `https://backend.brothersludo.in/storage/${profilephoto}`} 
  style={{width: '80px', height: '80px', borderRadius: '50%', marginTop: '50px'}} 
/>

               </div>
               <div  className='mt-2' style={{display:'flex', justifyContent:'center'}}>
         <h6  style={{color:'#000', fontWeight:'400'  }}>  {dataone?.mobile_number}               </h6>
               </div>
        

     
     <div className='mt-2 pb-4' >
     <div className='mx-4' style={{   display: "flex", justifyContent: "center" }}> 
      {isEditing ? (
        <input
          type="text"
          value={name}
          onChange={handleChange}
          style={{ color: "#959595", border: "1px solid #ccc", borderRadius: "4px", padding: "4px" }}
        />
      ) : (
        <h6 style={{ color: "#000", fontWeight: "400" }}>{dataone?.name}</h6>
      )}
      {isEditing ? (
        <FaCheck
          className="ms-4 mt-2 fs-5"
          style={{ color: "green", cursor: "pointer" }}
          onClick={handleSaveClick}
        />
      ) : (
        <FaPen
          className="ms-4"
          style={{ color: "blue", cursor: "pointer" }}
          onClick={handleEditClick}
        />
      )}
    </div>
    </div>
    </div>
    </div>
    <br/>



    <div  className='mt-4'>
        <h6>Complete Profile </h6>

        <div>
      {kycStatus === "pending" ? (
        <NavLink to="/ky3" style={{ textDecoration: "none" }}>
          <div
            className="card py-2 mt-3"
            style={{
              backgroundColor: "#cde8f86b",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
              border: "1px solid #cde8f8",
            }}
          >
            <div className="card-body py-0">
              <div className="row">
                <div className="col-3 mt-2">
                  <img src={kyc} style={{ width: "50%" }} alt="KYC" />
                </div>

                <div className="col-6  ">
                  <h6 className="  text-dark abcs" style={{paddingTop:'20px'}}>Complete KYC</h6>
                </div>
              </div>
            </div>
          </div>
        </NavLink>
      ) : (
        kycStatus === "approved" || kycStatus === "rejected" ? (
          handleModal(kycStatus === "approved" ? "KYC Approved" : "KYC Rejected")
        ) : null
      )}

      {/* Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="KYC Status"
        style={{
          content: { top: "50%", left: "50%", transform: "translate(-50%, -50%)" },
        }}
      >
        <h2>{modalMessage}</h2>
        <button onClick={() => setModalIsOpen(false)}>Close</button>
      </Modal>
    </div>
        </div>


<div className='card my-3 px-0' style={{border:'1px solid #cde8f8'}}>
  <div className='card-header px-0'  style={{backgroundColor:'#cde8f86b'}}>
  <h6 className='text-center py-1'   >Metrics</h6>
  </div>
  <div className='card-body'>
  <div className='row mt-4'>
    <div className='col-6'>
        <div className='card   ' style={{border:'1px solid #cde8f8'}}>
            <div className='card-header dolve mb-0' style={{backgroundColor:'#cde8f86b',borderBottom:'1px solid #cde8f8'}}>
         <p className='p-2 mb-0'> <img src={tal} style={{width:'15px'}} className='me-1'/>   games played</p>

            </div>
            <div className='card-body p-0' style={{boxShadow: '0 .125rem .25rem #00000014'}}>
           <p className='ps-3 py-3 mb-0'>0</p>
            </div>
        </div>
    </div>
    <div className='col-6'>
        <div className='card  ' style={{border:'1px solid #cde8f8'}}>
            <div className='card-header mb-0 dolve' style={{backgroundColor:'#cde8f86b',border:'1px solid #cde8f8'}}>
          
            <p className='p-2 mb-0   ' ><FaUserFriends className='me-1'/>   referral earning
            </p>

            </div>
            <div className='card-body p-0' style={{boxShadow: '0 .125rem .25rem #00000014'}}>
           <p className='ps-3 py-3 mb-0'>0</p>
            </div>
        </div>
    </div>

</div>

<div className='row mt-4'>
    <div className='col-6'>
        <div className='card' style={{border:'1px solid #cde8f8'}}>
            <div className='card-header dolve mb-0' style={{backgroundColor:'#cde8f86b',borderBottom:'1px solid #cde8f8'}}>
            <p className='p-2 mb-0  ' ><GiCrownCoin  className='me-2'/>
            chips won</p>

            </div>
            <div className='card-body p-0' style={{boxShadow: '0 .125rem .25rem #00000014'}}>
           <p className='ps-3 py-3 mb-0'>0.00</p>
            </div>
        </div>
    </div>
    <div className='col-6'>
        <div className='card  ' style={{border:'1px solid #cde8f8'}}>
            <div className='card-header dolve  mb-0'  style={{backgroundColor:'#cde8f86b',borderBottom:'1px solid #cde8f8'}}>
            <p className='p-2 mb-0  ' ><MdImageNotSupported   className='me-2'/>
            Penalty</p>

            </div>
            <div className='card-body p-0' style={{boxShadow: '0 .125rem .25rem #00000014'}}>
           <p className='ps-3 py-3 mb-0'>0</p>
            </div>
        </div>
    </div>

</div>
  </div>
</div>

 



<div className='mt-4'>
    <button className='btn btn-danger w-100 my-4 colab bg-white text-danger'  onClick={handleLogout}>LOG OUT</button>
</div>
          
        </div>
      </div>
    </div>
  )
}

export default Profile